<template>
  <div>
    <dl v-if="node && node.displayProperties" :class="'node tabular ' + (node.children ? '' : 'leaf')">
      <dt :style="'padding-left:' + (8 + (level - 1) * 15) + 'px'">
        <span class="button-column">
          <button v-if="node.children" type="button" @click="showClick">
            {{ showChildren ? '-' : '+' }}
          </button>
        </span>
        
        <span v-if="node.displayProperties.hasIcon">
          <img  :src="domain + node.displayProperties.icon">
        </span>
        <span v-else-if="level > 1" class="spacer">
        </span>
        
        <span class="name">
          {{ node.displayProperties.name }}
          <div v-if="level > 1 && node.sourceString" class="xsmall">
            {{ node.sourceString }}
          </div>
          <div v-else-if="level > 1 && node.displayProperties.description" class="xsmall">
            {{ node.displayProperties.description }}
          </div>
          <!--
          <small class="debug" style="display:none">{{ node }}</small>
          <small class="debug" style="display:none">{{ hash }}</small>
          -->
        </span>
        
        <span v-if="node.objectiveHash" class="number small">{{ objective.completionValue }}</span>
        
        <span v-if="node.completionInfo || node.intervalInfo" class="number small nowrap">
          {{ totalScore() }} pts
        </span>  

      </dt>

      <dl v-for="player in players" :key="player.key" class="player">
        <dt>{{ player.name }}</dt>
        
        <dd>

          <!-- Branch -->
          <span v-if="node.children && player.profile" :class="'node-total level' + level" v-html="playerTotalsDisplay(hash, player)"></span>

          <!-- Leaf -->
          <template v-if="!node.children">
          
            <!-- Collectibles -->
            <template v-if="player.profile">
              <span v-html="collectibleStateDisplay(player, hash)"></span>
              <!--
              <small class="debug">{{ collectibleState(player, hash) }}</small>
              <small class="debug">{{ hash }}</small>
              -->
            </template>
            
            <!-- Records -->
            <template v-if="player.profile">
              <span v-html="recordDisplay(player, hash)"></span>
              <!--
              <small class="debug">{{ record(player, hash) }}</small>
              -->
            </template>

            <!-- Metrics -->
            <template v-if="player.profile">
              <span v-html="metricDisplay(player, hash)"></span>
              <!--
              <small class="debug">{{ metric(player, hash) }}</small>
              <small class="debug">{{ hash }}</small>
              -->
            </template>
          
          </template>

          <!-- Branch completion -->
          <template v-if="node.completionRecordHash && player.profile.profileRecords.data.records[node.completionRecordHash]">
            <span v-html="recordDisplay(player, node.completionRecordHash, true)"></span>
          </template>
          
          <!-- Passed in root value -->
          <span v-if="rootValue">
            {{ eval(rootValue, player) }}
          </span>
        
        </dd>
      
      </dl>
    </dl>
    
    <template  v-if="showChildren && node.children">
      <Node v-for="child in node.children.presentationNodes" :key="child.presentationNodeHash" 
        :table="'DestinyPresentationNodeDefinition'" :hash="child.presentationNodeHash" :level="level + 1" 
      />
      <Node v-for="(child, index) in node.children.collectibles" :key="index" 
        :table="'DestinyCollectibleDefinition'" :hash="child.collectibleHash" :level="level + 1" 
      />
      <Node v-for="(child, index) in node.children.records" :key="index" 
        :table="'DestinyRecordDefinition'" :hash="child.recordHash" :level="level + 1" 
      />
      <Node v-for="(child, index) in node.children.metrics" :key="index" 
        :table="'DestinyMetricDefinition'" :hash="child.metricHash" :level="level + 1" 
      />
    </template>

  </div>
</template>

<style lang="scss">
@import "@/styles/global.scss";

dl.node {
  > dt {
    details > summary {
      list-style: none;
      cursor: pointer;
      &:focus { outline: none; };
    }
    details > summary::-webkit-details-marker {
      display: none;
    }
    .name {
      // padding-left: 5px;
      flex-basis: 100%;
    }
    span {
      margin-right: 5px;
      // &.spacer {
      //   display: block;
      //   width: 40px;
      //   height: 40px;
      //   flex-basis: 40px;
      //   min-width: 40px;
      // }
      &.button-column {
        min-width: 20px;
      }
      button {
        @extend .btn;
        width: 20px;
        height: 20px;
        padding: 0;
      }
      img { 
        display: block;
        width: 40px;
        height: 40px;
      }
    }
    .number {
      text-align: right;
      flex-basis: 0;
    }
  }
  > dl > dd {
    position: relative;
    .node-total {
      display: flex;
      width: 100%;
      text-align: right;
      justify-content: flex-end;
      font-size: 90%;
      &.level1 .total-visible { width: calc(100% - (1 * 25px) - 8px); }
      &.level2 .total-visible { width: calc(100% - (2 * 25px) - 8px); }
      &.level3 .total-visible { width: calc(100% - (3 * 25px) - 8px); }
      &.level4 .total-visible { width: calc(100% - (4 * 25px) - 8px); }
      &.level5 .total-visible { width: calc(100% - (5 * 25px) - 8px); }
      > span { 
        // border: $cell-border; 
        vertical-align: baseline; 
        display: flex; 
        align-items: center; 
        justify-content: flex-end;
        &.total-visible {
          color: $color-dark-text;
          font-size: 75%;
        }
      }
    }
    .obj-complete {
      color: #ffdd55;
    }
    .checkmark {
      position: absolute;
      top: 5px;
      left: 5px;
    }
  }
  
}
  
</style>

<script>
import { mapState } from 'vuex'
import * as api from '@/api'
import manifest from '@/utils/manifest';

export default {
  name: "Node",
  props: ['table', 'hash', 'level', 'rootValue'],
  data() {
    return {
      showChildren: false,
      node: [],
      domain: api.URL_DOMAIN
    }
  },
  computed: {
    ...mapState(['players', 'cacheNodeTotals']),
    objective() { return manifest.DestinyObjectiveDefinition[this.node.objectiveHash]; },
  },
  methods: {
    showClick: function() {
      this.showChildren = !this.showChildren;
    },
    eval: function(data, player) {
      if (player) {
        return eval(data);
      }
    },
    totalScore() {
      if (this.node.completionInfo.ScoreValue > 0) {
        return this.node.completionInfo.ScoreValue;
      } else if (this.node.intervalInfo) {
        let scoreTotal = 0;
        for (const objective of this.node.intervalInfo.intervalObjectives) {
          scoreTotal += objective.intervalScoreValue;  
        }
        return scoreTotal;
      }
    },
    collectibleState: function(player, hash) {
      if (player.profile.profileCollectibles && player.profile.profileCollectibles.data.collectibles[hash]) {
        return player.profile.profileCollectibles.data.collectibles[hash].state;
      } else if (player.profile.characterCollectibles) {
        //if (hash == '2941099476') return [1, 1, 1];
        let states = [];
        for (const characterId in player.profile.characterCollectibles.data) {
          if (player.profile.characterCollectibles.data[characterId].collectibles[hash]) {
            states.push(player.profile.characterCollectibles.data[characterId].collectibles[hash].state);
          }
        }
        return states;
      }
    },
    collectibleStateDisplay: function(player, hash) {
      const stateRaw = this.collectibleState(player, hash);
      const states = Array.isArray(stateRaw) ? stateRaw : [stateRaw];
      for (const state of states) {
        if (state !== undefined) {
          if (!(state & 1)) {
            return '&check;'
          } else if (state & 4) {
            return '<span class="hidden">hidden</span>';
          }
        }
      }
    },
    record(player, hash) {
      if (player.profile.profileRecords && player.profile.profileRecords.data.records[hash]) {
        return player.profile.profileRecords.data.records[hash];
      } else if (player.profile.characterRecords) {
        for (const characterId in player.profile.characterRecords.data) {
          if (player.profile.characterRecords.data[characterId].records[hash]) {
            return player.profile.characterRecords.data[characterId].records[hash];
          }
        }
      }
    },
    recordDisplay: function(player, hash, ignoreUnredeamed) {
      const record = this.record(player, hash);
      if (record) {
        const state = record.state;
        let hint = '';
        if (record.intervalObjectives) {
          const interval = record.intervalObjectives[record.intervalObjectives.length - 1];
          return this.progressDisplay(interval.progress, interval.completionValue);
        } else if (record.objectives) {
          let objProgress = 0;
          let objTotal = 0;
          for (const objective of record.objectives) {
            objProgress += Math.min(objective.progress, objective.completionValue);
            objTotal += objective.completionValue;
            // hint of all the objective steps
            let hintLine = '';
            if (manifest.DestinyObjectiveDefinition[objective.objectiveHash].progressDescription) {
              hintLine += manifest.DestinyObjectiveDefinition[objective.objectiveHash].progressDescription + ': ';
            }
            hintLine += objective.progress + ' of ' +  objective.completionValue + '\n';
            hint += hintLine;
          }
          return this.progressDisplay(objProgress, objTotal, state, hint);
        } else if (state & 1 || (ignoreUnredeamed && (state == 0))) {
          return '&check;';
        } else if (state == 0) {
          return '&#9634;'
        } else if (state & 16) {
          return '<span class="hidden">hidden</span>';
        }
      }
    },
    progressDisplay: function(progress, total, state, hint) {
      const title = (hint) ? hint : `${progress} of ${total}`;
      const percentage = Math.round(progress / total * 100);
      if (state & 16) {
          return `<span class="hidden" title="${title}">hidden</span>`;
      } else if (percentage >= 100 || state & 1) {
        return `<span title="${title}">&check;</span>`;
      } else if (percentage > 0) {
        return `<span class="progress" title="${title}">${percentage}%</span>`;
      } else if (hint != '') {
        return `<span class="progress" title="${title}">-</span>`;
      } else {
        return '';
      }
          
    },
    playerTotals: function(hash, player) {
      // cached result for performance
      if (this.$store.state.cacheNodeTotals[hash + '_' + player.id]) {
        if (this.$store.state.cacheNodeTotals[hash + '_' + player.id].visible) {
          return this.$store.state.cacheNodeTotals[hash + '_' + player.id];
        }
      }

      let result = {
        acquired: 0,
        visible: 0,
        debug: ''
      }
      const node = manifest.DestinyPresentationNodeDefinition[hash];

      //result.debug = node;
      
      if (node.children && node.children.collectibles && node.children.collectibles.length) {
        // collectibles
        for(const collectibleNode of node.children.collectibles) {
          if (collectibleNode) {
            const stateRaw = this.collectibleState(player, collectibleNode.collectibleHash);
            const states = Array.isArray(stateRaw) ? stateRaw : [stateRaw];
            let acquiredCounted = false;
            let visibleCounted = false;
            for (const state of states) {
              if (!(state & 1) && !acquiredCounted) {
                result.acquired++;
                acquiredCounted = true;
              }
              if (!(state & 4) && !visibleCounted) {
                result.visible++;
                visibleCounted = true;
              }
            }
            // if (!manifest.DestinyCollectibleDefinition[collectibleNode.collectibleHash].redacted) {
          }
        }
        return result;
      } else if (node.children && node.children.records && node.children.records.length) {
        // records
        for(const recordNode of node.children.records) {
          const record = this.record(player, recordNode.recordHash);
          if (recordNode && record) {
            const state = record.state;
            if ((state & 1) || (state == 0)) {
              result.acquired++;
            }
            if (!(state & 16)) {
              result.visible++;
            }
          }
        }
        return result;
      } else if (node.children && node.children.metrics && node.children.metrics.length) {
        // metrics
        for(const metricNode of node.children.metrics) {
          const metric = this.metric(player, metricNode.metricHash);
          if (metric) {
            if (metric.objectiveProgress && metric.objectiveProgress.complete) {
              result.acquired++;
            }
            if (!metric.invisible) {
              result.visible++;
            }
          }
        }
        return result;
      } else if (node.children && node.children.presentationNodes) {
        // recursion through branches
        for(const presentationNode of node.children.presentationNodes) {
          const totals = this.playerTotals(presentationNode.presentationNodeHash, player);
          if (totals) {
            result.acquired += totals.acquired;
            result.visible += totals.visible;
          }
        }
        this.$store.state.cacheNodeTotals[hash + '_' + player.id] = result;
        return result;
      }
    },
    playerTotalsDisplay: function(hash, player) {
      //const label = manifest.DestinyPresentationNodeDefinition[hash].displayProperties.name;
      //console.time(label);
      const playerTotalValues = this.playerTotals(hash, player);
      //console.timeEnd(label);
      if (playerTotalValues) {
        return `<span>${playerTotalValues.acquired}</span><span class="total-visible">/ ${playerTotalValues.visible}</span>` + playerTotalValues.debug;
      }
    },
    metric: function(player, hash) {
      if (player.profile.metrics && player.profile.metrics.data.metrics[hash]) { 
        return player.profile.metrics.data.metrics[hash];
      }
    },
    metricDisplay: function(player, hash) {
      const metric = this.metric(player, hash);
      if (metric && metric.objectiveProgress) {
        let result = metric.objectiveProgress.progress;
        let completionValue = metric.objectiveProgress.completionValue;
        let objectiveDef = manifest.DestinyObjectiveDefinition[metric.objectiveProgress.objectiveHash];
        if (objectiveDef && objectiveDef.inProgressValueStyle == 7) {
          // time
          result = new Date(result).toISOString().substr(11, 8);
          completionValue = new Date(completionValue).toISOString().substr(11, 8);
        } else if (objectiveDef && objectiveDef.inProgressValueStyle == 13) {
          // KDA
          result = Number(result / 100).toLocaleString(2);
          completionValue = Number(completionValue / 100).toLocaleString(2);
        } else if (objectiveDef && objectiveDef.inProgressValueStyle == 12) {
          // percentage
          result = result + '%';
          completionValue = completionValue + '%';
        } else {
          result = Number(result).toLocaleString();
          completionValue = Number(completionValue).toLocaleString();
        }
        let css = (metric.objectiveProgress.complete) ? 'obj-complete' : '';
        let hint = result + ' of ' +  completionValue;
        result = `<span class="${css}" title="${hint}">${result}</span>`;
        return result;
      }
    }
  },
  async mounted() {
    this.node = manifest[this.table][this.hash];
  }
  
}
</script>